var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32,
    stroke: "#909090"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 35.921C35.3395 35.921 37.6145 33.6289 37.6145 30.7894L37.6316 20.5262C37.6316 17.6868 35.3395 15.3947 32.5001 15.3947C29.6606 15.3947 27.3685 17.6868 27.3685 20.5262V30.7894C27.3685 33.6289 29.6606 35.921 32.5001 35.921ZM41.5658 30.7894C41.5658 35.921 37.2211 39.5131 32.5001 39.5131C27.779 39.5131 23.4343 35.921 23.4343 30.7894H20.5264C20.5264 36.6223 25.179 41.446 30.7895 42.2841V47.8947H34.2106V42.2841C39.8211 41.4631 44.4737 36.6394 44.4737 30.7894H41.5658Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.0526,
    height: 41.0526,
    fill: "white",
    transform: "translate(11.9736 11.9736)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/micOn.797f95b8ed8d69d9c147a131d71f5d47.svg";
export { ForwardRef as ReactComponent };